import { Button } from "@jugl-web/ui-kit";
import { ChatbotPreviewBackground } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/screens/WebChatBotAccountScreen/components/ChatbotPreviewBackground";
import { FC, ReactNode } from "react";
import { ReactComponent as InfoCircleIcon } from "./assets/info-circle.svg";

export type ChannelPreviewPanelProps = {
  icon: ReactNode;
  title: ReactNode;
  subtitle: ReactNode;
  badge?: ReactNode;
  action: {
    label: string;
    onClick: () => void;
    iconEnd?: ReactNode;
    variant?: "primary" | "secondary";
    isDisabled?: boolean;
  };
  bannerContent: ReactNode;
  bannerIllustration: ReactNode;
  showInfoIcon?: boolean;
};

export const ChannelPreviewPanel: FC<ChannelPreviewPanelProps> = ({
  icon,
  title,
  subtitle,
  badge,
  action,
  bannerContent,
  bannerIllustration,
  showInfoIcon = true,
}) => (
  <ChatbotPreviewBackground>
    <div className="flex h-full w-full animate-fade-in items-center justify-center p-10">
      <div className="flex w-full max-w-177.5 flex-col gap-10">
        <div className="flex flex-col gap-10">
          {badge}
          <div className="flex items-center justify-between gap-6">
            <div className="flex min-w-0 items-center gap-6">
              <div className="shrink-0">{icon}</div>
              <div className="flex min-w-0 flex-col gap-2">
                <span className="font-secondary text-[22px] font-medium text-black">
                  {title}
                </span>
                <span className="font-secondary text-sm text-[#828282] italic">
                  {subtitle}
                </span>
              </div>
            </div>

            <Button
              onClick={action.onClick}
              variant={action.variant ?? "primary"}
              iconEnd={action.iconEnd}
              isDisabled={action.isDisabled}
              className="shrink-0"
            >
              {action.label}
            </Button>
          </div>
        </div>

        <div className="flex items-center justify-between gap-6 rounded-2xl bg-grey-100 px-8 py-6">
          <div className="flex min-w-0 items-center gap-2.5">
            {showInfoIcon && <InfoCircleIcon />}
            <div className="min-w-0 font-secondary text-sm leading-[150%] text-dark">
              {bannerContent}
            </div>
          </div>
          <div className="shrink-0">{bannerIllustration}</div>
        </div>
      </div>
    </div>
  </ChatbotPreviewBackground>
);
